export const startOfMatchMark = '\u0001';
export const endOfMatchMark = '\u0002';
